import styled from 'styled-components';

import {breakpoint} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    gap: 1.5rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div<{needMargin?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
    flex: 0 1 auto;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: ${(p) => (p.needMargin ? '20px' : '0')};
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    @media (max-width: ${breakpoint.phone}) {
        min-width: unset;
        flex-wrap: wrap;
        flex-grow: 1;
    }
`;
